module.exports = __webpack_public_path__ + "static/media/loader.a4f2cb80.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/loader.gif
// module id = 956
// module chunks = 0